import { Trash2Icon } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { NewPayment } from '../../containers/add-payments/add-payments';

import styles from './new-payment-row.module.scss';

type Props = {
    payment: NewPayment;
    gatewayLabel: string;
};

const NewPaymentRow = ({ payment, gatewayLabel }: Props) => (
    <li className={styles.record} data-id={payment.uuid}>
        <span className={styles.amount}>{payment.amount.toFixed(2)}</span>
        <span className={styles.gateway}>{gatewayLabel}</span>
        <span className={styles.date}>
            {format(payment.date, "dd 'de' MMM. 'de' yyyy", {
                locale: es,
            })}
        </span>
        <div className={styles.actions} data-action="delete-payment">
            <Trash2Icon size={16} />
        </div>
    </li>
);

export { NewPaymentRow };
